import React from "react";
import StudiesSection from "../components/home/StudiesSection";
import "./GalleryPage.css";

export default function GalleryPage() {
  return (
    <main id="main" className="gallery-page" data-testid="gallery-page">
      <header className="gallery-hero">
        <div className="gallery-hero-grid" />
        <div className="gallery-hero-inner">
          <span className="gallery-eyebrow">Galerie — Projets &amp; concepts</span>
          <h1 className="gallery-title">CE QUE NOUS<br /><span>METTONS EN PLAN.</span></h1>
          <p className="gallery-intro">Fiches d'études, rendus CAO et aperçus de plans. Chaque fiche précise la nature de ses visuels.</p>
        </div>
      </header>
      <StudiesSection />
    </main>
  );
}
